const validationHelper = (value, rules) => {
  let isValid = true;

  if (rules.checkbox) {
    isValid = value == "true" && isValid;
  }
  if (rules.require) {
    isValid = value.trim() != "" && isValid;
  }
  if (rules.noSpecCharAllowSpace) {
    isValid = /^[A-Za-z0-9 ]{1,}$/.test(value) && isValid;
  }
  if (rules.dateValid) {
    isValid = new Date(value).getTime() > new Date().getTime() && isValid;
  }
  if (rules.radioChecked) {
    isValid = value == "checked" && isValid;
  }
  if (rules.noSpecChar) {
    isValid = /^[A-Za-z0-9]{1,}$/.test(value) && isValid;
  }
  if (rules.name) {
    isValid = /^[A-Za-z0-9 ]{1,}$/.test(value) && isValid;
  }
  if (rules.alphabetWithSpecialChar) {
    isValid = /^[A-Za-z' -]{1,}$/.test(value) && isValid;
  }
  if (rules.minLength) {
    isValid = value.trim().length >= rules.minLength && isValid;
  }
  if (rules.maxLength) {
    isValid = value.trim().length <= rules.maxLength && isValid;
  }
  if (rules.maxLengthWithoutTrim) {
    isValid = value.length <= rules.maxLengthWithoutTrim && isValid;
  }
  if (rules.isNumber) {
    isValid = typeof value.trim == "number" ? true : false && isValid;
  }
  if (rules.email) {
    isValid =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        value.trim()
      ) && isValid;
  }
  if (rules.phone) {
    isValid =
      /^[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/.test(value.trim()) &&
      isValid;
  }
  if (rules.passsword) {
    isValid =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$_()-+#!%*?^&.,():{}[]{6,20}$/.test(
        value
      ) && isValid;
  }
  if (rules.matchPassword) {
    isValid =
      document.querySelector('[name="password"]').value == value && isValid;
  }
  if (rules.require) {
    isValid = value.trim() != "" && isValid;
  }
  if (rules.zipcode) {
    isValid = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value.trim()) && isValid;
  }
  return isValid;
};

export default validationHelper;
